import React from 'react';
import { Search, Plus, X } from 'lucide-react';

const Searchbar = ({ searchTerm, setSearchTerm, onCreateFromSearch, showCreateButton, onClearSearch }) => {
  return (
    <div className="relative">
      <div className="relative flex items-center">
        <Search className="absolute left-3 text-neutral-500" size={20} />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search baskets..."
          className="w-full pl-10 pr-[100px] py-2 border-2 border-neutral-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-cranberry-700"
        />
        <div className="absolute right-2 flex items-center gap-2">
          {showCreateButton && searchTerm.trim() && (
            <button
              onClick={() => onCreateFromSearch(searchTerm)}
              className="px-3 py-1 bg-cranberry-700 text-white text-sm rounded-lg border border-neutral-900 
                font-medium hover:bg-cranberry-600 transition-colors flex items-center gap-1"
            >
              <Plus size={16} />
              Create
            </button>
          )}
          {searchTerm && (
            <button
              onClick={onClearSearch}
              className="p-1 text-neutral-400 hover:text-neutral-600 transition-colors"
              aria-label="Clear search"
            >
              <X size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Searchbar;
